<template>
  <div>
    <vue-pdf-embed :source="src" />
  </div>
</template>

<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";

export default {
  name: "PdfViewer",
  components: {
    VuePdfEmbed
  },
  props: ["src"]
};
</script>
